export default __webpack_public_path__ + "e1541fefc9895c3dadeb248b24e69f9c.svg";